export const ru = {
    'add-clients': 'Изменить доступ к пакету'
};
